import { ClientBusinessPartialModel } from 'app/client/clientBusiness/models/ClientBusiness';
import moment from 'moment';
import { ChipModel } from 'shared/components/filters/Chip';
import FilterChipsBar from 'shared/components/filters/FilterChipsBar';
import { EventosFilters } from '../utils/eventosStorage';

interface Props {
  filters: EventosFilters;
  clients: ClientBusinessPartialModel[];
  onFiltersChange: (filters: EventosFilters) => void;
}

const EventoChipsBar = ({ filters, clients, onFiltersChange }: Props) => {
  const chips: ChipModel[] = [];

  if (filters.businessClientId) {
    const client = clients.find((c) => c.id === filters.businessClientId);
    chips.push({
      label: 'Cliente:',
      value: client?.fantasyName ?? filters.businessClientId,
      onDelete: () => onFiltersChange({ ...filters, businessClientId: null })
    });
  }

  if (filters.fromDate) {
    chips.push({
      label: 'Desde:',
      value: moment(filters.fromDate).format('DD/MM/YYYY'),
      onDelete: () => onFiltersChange({ ...filters, fromDate: null })
    });
  }

  if (filters.toDate) {
    chips.push({
      label: 'Hasta:',
      value: moment(filters.toDate).format('DD/MM/YYYY'),
      onDelete: () => onFiltersChange({ ...filters, toDate: null })
    });
  }

  return <FilterChipsBar chips={chips} />;
};

export default EventoChipsBar;
